import LTR from "@brand-icons/ploom/mail-classic/mail-classic-ltr.svg";

import { iconFactory } from "../iconFactory";

export const MailClassicIcon = iconFactory("MailClassicIcon", LTR);
